import { RouteRecordRaw } from 'vue-router';

import { ENTRY_POINTS } from '@constants/entry-points';
import authRoutes from '@router/routes/auth';
import userAppRoutes from '@router/routes/user-app';
import tenantAppRoutes from '@router/routes/tenant-app';
import errorRoutes from '@router/routes/error';
import sandboxRoutes from '@router/routes/sandbox';

const routes: Array<RouteRecordRaw> = [
  {
    path: '',
    redirect: ENTRY_POINTS.PATH.TENANT_HOME(),
  },
  ...authRoutes,
  ...userAppRoutes,
  ...tenantAppRoutes,
  ...sandboxRoutes,
  ...errorRoutes,
];

export default routes;
